var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 111,
    viewBox: "0 0 219 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 51.2622C18.27 81.8422 71.96 114.512 108.22 104.872C153.98 92.7122 176.52 28.9522 145.03 8.2422C137.09 3.0222 123.85 2.1122 116.27 8.3922C112.27 11.7022 110.07 16.8422 109.54 22.0022C109.01 27.1422 110.06 32.1922 111.42 37.1222C103.54 30.8422 95.36 24.1722 85.02 22.8622C64.64 20.2622 50.52 44.6422 61.51 61.6422C71.66 77.3322 93.41 82.1922 110.76 82.8922C129.98 83.6722 146.44 83.8322 165.35 80.2822C184.26 76.7322 202.89 68.9922 216.38 55.2722",
    stroke: "#F57D7D",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGroup);
export default __webpack_public_path__ + "static/media/smallGroup.e926a8c1881780b4e6e8ababdf79b632.svg";
export { ForwardRef as ReactComponent };